import { Stack, Box, Text } from 'braid-design-system';
import TextButton from 'src/components/common/TextButton';
import translations from './.vocab/';
import { useTranslations } from '@vocab/react';
interface Props {
  email: any;
  showEditButton: boolean;
  onEditEmail: () => void;
}
const EmailSection = ({ email, onEditEmail, showEditButton }: Props) => {
  const { t } = useTranslations(translations);
  return (
    <Stack space="xsmall">
      <Box
        width="full"
        display="flex"
        justifyContent="spaceBetween"
        alignItems="flexEnd"
        paddingTop="xsmall"
        paddingBottom="small"
      >
        <Stack space="medium">
          <Text weight="medium">{email.value}</Text>
        </Stack>
        {showEditButton && (
          <Text>
            <TextButton
              data-testid="add-candidate-edit-email"
              onClick={onEditEmail}
            >
              {t('Edit')}
            </TextButton>
          </Text>
        )}
      </Box>
    </Stack>
  );
};

export default EmailSection;
